import { IconButton, ListItemIcon, Menu, MenuItem, Typography } from "@mui/material";
import { Avatar } from "ds-form";
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import ModeEditOutlineIcon from '@mui/icons-material/ModeEditOutline';
import { useTranslation } from "react-i18next";
import '../styles/AccessCard.css';
import { useRest } from "react-common";
import { useState } from "react";
import { Check } from "@mui/icons-material";
import { ROLE_AUTHOR, ROLE_OWNER, ROLE_PRESENTER, ROLE_READER } from "../utils/commonUtils";


const AccessCard = ({access, user, slideshowID, refreshAccesses, isOwner, accessCardPresenter, roles}) => {

    const [roleName, setRoleName] = useState(access.roles)
    const { t } = useTranslation();
    const { deleteData, patchData } = useRest();
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const showAccessMenu = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const deleteAccess = () => {
        deleteData("Access/" + access.id, {
            slideshowID: slideshowID,
            roles: roles
        }).then(() => {
            refreshAccesses()
        })
    } 

    const changeRole = (role) => {
        patchData("Access/" + access.id, {
            roles: role,
            slideshowID: slideshowID,
        })
        .then(() => {
            refreshAccesses()
            setRoleName(role)
            setAnchorEl(null)
        })
    }

    return (
        <div className="accessCard">
            <div className="user">
                <Avatar user={{value: user.login, label: user.firstName}}/>
                
                <div className="info">
                    <Typography variant="subtitle1">{user.firstName + " " + user.lastName}</Typography>
                    <Typography variant="subtitle2">
                        {!accessCardPresenter && (roleName & ROLE_OWNER) === ROLE_OWNER && t("roles.owner")}
                        {!accessCardPresenter && (roleName & ROLE_AUTHOR) === ROLE_AUTHOR && t("roles.author")}
                        {!accessCardPresenter && (roleName & ROLE_READER) === ROLE_READER && t("roles.reader")}
                        {accessCardPresenter && (roleName & ROLE_PRESENTER) === ROLE_PRESENTER && t("roles.presenter")}
                    </Typography>   
                </div>
            </div>

            {isOwner && 
                <div>
                    {(roleName & ROLE_OWNER) !== ROLE_OWNER &&
                        <div className="actions">
                            <IconButton>
                                <DeleteOutlineIcon 
                                    onClick={deleteAccess}/>
                            </IconButton>    
                            {!accessCardPresenter &&
                                <div>
                                    <IconButton onClick={showAccessMenu}>
                                        <ModeEditOutlineIcon />
                                    </IconButton>
                                    <Menu
                                        anchorEl={anchorEl}
                                        open={open}
                                        onClose={handleClose}
                                    >
                                        <MenuItem onClick={() => changeRole(2)}>
                                            <ListItemIcon>{roleName === 2 && <Check />}</ListItemIcon>
                                            {t("roles.author")}
                                        </MenuItem>
                                        <MenuItem onClick={() => changeRole(4)}>
                                            <ListItemIcon>{roleName === 4 && <Check />}</ListItemIcon>
                                            {t("roles.reader")}
                                        </MenuItem>
                                    </Menu>    
                                </div>    
                            }      
                        </div>  
                    }
                </div>
            }
            
        </div>
    )
}


export default AccessCard;